import axiosClient from '../configs/axios';


class DeliveryChallanCustomerService {
    // Get list 
    async getDeliverycustomerChallanList(params) {
        try {
            const response = await axiosClient.get(
                `/delivery-challan-customer/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add 
    async addDeliverycustomerChallan(data) {
        try {
            const response = await axiosClient.post('/delivery-challan-customer/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteDeliverycustomerChallan(data) {
        try {
            const response = await axiosClient.put(`/delivery-challan-customer/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new DeliveryChallanCustomerService(); 